import { useLocation } from "react-router-dom";
import ReactPlayer from "react-player";
import { Box, List, ListItem, ListItemIcon, Typography } from "@mui/material";

import { ApplicationRoute } from "../../../constants/ApplicationUrl";
import {
  BackLink,
  BoxInnerContainer,
  BoxOuterContainer,
  VideoContainer,
  VideoPlayerBox,
  LongText,
} from "../styles/style";
import fontWeight from "../../../styles/mui/fontWeight";
import { colors } from "../../../styles/colors";
import { convertTimeToMinutes, getValue } from "../../../utils";
import { FaCircleIcon } from "../../../app/styles/styles";

const VideoPlayer = () => {
  const location = useLocation();
  const { videoUrl, viewVideoData } = location.state || {};

  const bookmarks = viewVideoData.bookmarks
    ? viewVideoData.bookmarks.split(";")
    : [];

  const sortedBookmarks = bookmarks
    ? bookmarks
        .map((bookmark: any) => {
          const [time, description] = bookmark.trim().split(" - ");
          return {
            time: time.replace("-", "").trim(),
            description: description ? description.trim() : "",
          };
        })
        .sort(
          (a: any, b: any) =>
            convertTimeToMinutes(a.time) - convertTimeToMinutes(b.time)
        )
        .map(
          (bookmark: any) =>
            `${bookmark.time} - ${getValue(bookmark, "description", "")}`
        )
    : [];

  const typography = (value: string) => {
    return (
      <Typography
        variant="h1"
        color={colors.portalColor[25]}
        fontWeight={fontWeight[7]}
        sx={LongText}
      >
        {value}
      </Typography>
    );
  };

  return (
    <Box sx={BoxOuterContainer}>
      <BackLink href={ApplicationRoute.TRAINING}>Back</BackLink>
      <Box sx={BoxInnerContainer}>
        <Box sx={VideoPlayerBox}>
          <Box sx={VideoContainer}>
            <ReactPlayer url={videoUrl} controls width="100%" height="auto" />
          </Box>
          <Box mt={1}>
            {typography(viewVideoData.title)}
            <Typography
              variant="h4"
              color={colors.portalColor[26]}
              fontWeight={fontWeight[2]}
              mt={2}
              sx={LongText}
            >
              {viewVideoData.description}
            </Typography>
            <Box mt={2}>{typography("Bookmarks:")}</Box>
            <List>
              {sortedBookmarks.map((bookmark: string) => (
                <ListItem key={bookmark}>
                  <ListItemIcon>
                    <FaCircleIcon />
                  </ListItemIcon>
                  <Typography
                    variant="h4"
                    color={colors.portalColor[26]}
                    fontWeight={fontWeight[2]}
                  >
                    {bookmark}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default VideoPlayer;
